import {
  reduxCompaniesOverviewsActions,
  useReduxCompaniesOverviewStorage,
} from './companies-overview/companiesOverviewStorage';
import {
  reduxFormationsActions,
  useReduxFormationsStorage,
} from './formations/formationsStorage';
import {
  reduxIntelWorkspaceItemsActions,
  useReduxIntelWorkspaceItemsStorage,
} from './intel-query/intelWorkspaceItemsStorage.ts';
import {
  reduxCompanyKPIsActions,
  useReduxCompanyKPIsStorage,
} from './kpi/companyKPIsStorage';
import {
  reduxMergersAndAcquisitionsActions,
  useReduxMergersAndAcquisitionsStorage,
} from './mergers-and-acquisitions/mergersAndAcquisitionsStorage';

import {
  reduxMonthlyStatsActions,
  useReduxMonthlyStatsStorage,
} from '@pn/core/storage/intel/companyStatsStorage';
import {
  reduxIntelReportsActions,
  useReduxIntelReportsStorage,
} from './report/reportsStorage.ts';
import {
  reduxIntelUIActions,
  useReduxIntelUIStorage,
} from './intel-ui/intelUiStorage';

/**
 * Singular company data section
 */
export const mergersAndAcquisitionsActions = reduxMergersAndAcquisitionsActions;
export const useMergersAndAcquisitionsStorage =
  useReduxMergersAndAcquisitionsStorage;

export const monthlyStatsActions = reduxMonthlyStatsActions;
export const useMonthlyStatsStorage = useReduxMonthlyStatsStorage;
export const companyKPIsActions = reduxCompanyKPIsActions;
export const useCompanyKPIsStorage = useReduxCompanyKPIsStorage;

export const useCompaniesOverviewStorage = useReduxCompaniesOverviewStorage;
export const companiesOverviewsActions = reduxCompaniesOverviewsActions;

export const useFormationsStorage = useReduxFormationsStorage;
export const formationsActions = reduxFormationsActions;

export const useIntelWorkspaceItemsStorage = useReduxIntelWorkspaceItemsStorage;
export const intelWorkspaceItemsActions = reduxIntelWorkspaceItemsActions;

export const useIntelReportsStorage = useReduxIntelReportsStorage;
export const intelReportsActions = reduxIntelReportsActions;

export const useIntelUIStorage = useReduxIntelUIStorage;
export const intelUIActions = reduxIntelUIActions;
